import update from 'immutability-helper';

import { Configuration } from '../../../../interfaces/Configuration';
import { SlotType } from '../../../../interfaces/SlotDefinition';
import SlotService from '../../../../services/SlotService';

export const removeArticleFromConfiguration = (
  configuration: Configuration,
  articleId: string,
): Configuration => {
  const childrenIds = configuration.getChildren(articleId);
  childrenIds.forEach((id) => (configuration = removeArticleFromConfiguration(configuration, id)));

  const articleToRemove = configuration.articles.find((article) => article.id === articleId);

  const requiredConnectArticles = configuration.requiredConnectArticles.filter(
    (requiredConnectArticle) =>
      articleToRemove.requiredConnectArticleId !== requiredConnectArticle.id,
  );

  const requiredLightingArticles = configuration.requiredLightingArticles.filter(
    (requiredLightingArticle) =>
      !articleToRemove.requiredLightingArticlesIds.includes(requiredLightingArticle.id),
  );

  const articles = configuration.articles.filter((article) => article.id !== articleId);

  const slotIdsToBeFreed = configuration.slots
    .filter((slot) => SlotService.slotHasChild(slot, articleId))
    .map((slot) => slot.id);

  const slots = configuration.slots
    .filter((slot) => slot.parentId !== articleId)
    .map((slot) => {
      if (slotIdsToBeFreed.includes(slot.id)) {
        if (slot.type === SlotType.LINE) {
          return {
            ...slot,
            children: slot.children.filter((s) => s.id !== articleId),
          };
        }
        return {
          ...slot,
          childId: undefined,
        };
      }
      return slot;
    })
    .map((slot) => {
      if (slot.type === SlotType.LINE) {
        return slot;
      }
      if (slot.blockedBy === articleId) {
        return {
          ...slot,
          blockedBy: undefined,
        };
      }
      return slot;
    });

  configuration = update(configuration, {
    articles: {
      $set: articles,
    },
    slots: {
      $set: slots,
    },
    requiredConnectArticles: {
      $set: requiredConnectArticles,
    },
    requiredLightingArticles: {
      $set: requiredLightingArticles,
    },
  });
  return configuration;
};
